import DetailView from "@/views/detail/DetailView.vue";

import CloneDetail from "@/views/detail/CloneDetail";
import CloneEndDetail from "@/views/detail/CloneEndDetail";
import EcotypeDetail from "@/views/detail/EcotypeDetail";
import MarkerDetail from "@/views/detail/MarkerDetail";
import HostStrainDetail from "@/views/detail/HostStrainDetail";
import LibraryDetail from "@/views/detail/LibraryDetail";
import LocusDetail from "@/views/detail/LocusDetail";
import GeneDetail from "@/views/detail/GeneDetail";
import GermplasmDetail from "@/views/detail/GermplasmDetail";
import PolymorphismDetail from "@/views/detail/PolymorphismDetail";
import KeywordDetail from "@/views/detail/KeywordDetail";
import PersonDetail from "@/views/detail/PersonDetail";
import OrganizationDetail from "@/views/detail/OrganizationDetail";
import ProteinDetail from "@/views/detail/ProteinDetail";
import ProtocolDetail from "@/views/detail/ProtocolDetail";
import PublicationDetail from "@/views/detail/PublicationDetail";
import TransposonDetail from "@/views/detail/TransposonDetail";
import TransposonFamilyDetail from "@/views/detail/TransposonFamilyDetail";
import VectorDetail from "@/views/detail/VectorDetail";
import SymbolDetail from "@/views/detail/SymbolDetail";
import MicroarrayElementDetail from "@/views/detail/MicroarrayElementDetail";
import SequenceDetail from "@/views/detail/SequenceDetail";
import AnalysisReferenceDetail from "@/views/detail/AnalysisReferenceDetail";
import CommunicationDetail from "@/views/detail/CommunicationDetail";
import store from '../store/store';

const requireAccess = async (to, from, next) => {
  
  const userStatus = store.getters.userStatus;
  console.log('Full userStatus:', userStatus);
  
  if ((userStatus.isLoggedIn && userStatus.orcidId) || userStatus.subscriptionStatus === 'subscribed') {
    console.log('Access granted');
    next();
  } else {
    console.log('Access denied');
    next('/access-denied');
  }
};

export const detailRoutes = {
  path: "/",
  name: "DetailView",
  component: DetailView,
  children: [
    {
      path: "/clone",
      name: "CloneDetail",
      component: CloneDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/cloneend",
      name: "CloneEndDetail",
      component: CloneEndDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/ecotype",
      name: "EcotypeDetail",
      component: EcotypeDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/locus",
      name: "LocusDetail",
      component: LocusDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/marker",
      name: "MarkerDetail",
      component: MarkerDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/gene",
      name: "GeneDetail",
      component: GeneDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/germplasm",
      name: "GermplasmDetail",
      component: GermplasmDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/hoststrain",
      name: "HostStrainDetail",
      component: HostStrainDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/library",
      name: "LibraryDetail",
      component: LibraryDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/person",
      name: "PersonDetail",
      component: PersonDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/organization",
      name: "OrganizationDetail",
      component: OrganizationDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/polyallele",
      name: "PolymorphismDetail",
      component: PolymorphismDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/protein",
      name: "ProteinDetail",
      component: ProteinDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/protocol",
      name: "ProtocolDetail",
      component: ProtocolDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/publication",
      name: "PublicationDetail",
      component: PublicationDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/transposon",
      name: "TransposonDetail",
      component: TransposonDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/transposonfamily",
      name: "TransposonFamilyDetail",
      component: TransposonFamilyDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/keyword",
      name: "KeywordDetail",
      component: KeywordDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/vector",
      name: "VectorDetail",
      component: VectorDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/genesymbol",
      name: "SymbolDetail",
      component: SymbolDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/sequence",
      name: "SequenceDetail",
      component: SequenceDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/array_element",
      name: "MicroarrayElementDetail",
      component: MicroarrayElementDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/analysisreference",
      name: "AnalysisReferenceDetail",
      component: AnalysisReferenceDetail,
      beforeEnter: requireAccess,
    },
    {
      path: "/communication",
      name: "CommunicationDetail",
      component: CommunicationDetail,
      beforeEnter: requireAccess,
    }
  ],
};
